import styled, { css } from 'styled-components'

export const Container = styled.div`
    width: 100%;
`

export const Content = styled.div`
    padding: 0 16px 10px 16px;
`

export const FormItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: var(--font-size-normal);
    margin-bottom: 8px;
`

export const FormItemContent = styled.div`
    width: 100%;
`
